import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/pshemcio/webhorizon/elektroszaman/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/pshemcio/webhorizon/elektroszaman/src/components/shared/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/styles/embla-carousel.css");
